"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Backdrop = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var framer_motion_1 = require("framer-motion");
var tokens_1 = __importDefault(require("@servicetitan/tokens"));
var internal_1 = require("../../internal");
exports.Backdrop = react_1.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, _b = _a.closeOnClick, closeOnClick = _b === void 0 ? true : _b, onClick = _a.onClick, _c = _a.portal, portal = _c === void 0 ? true : _c, transitionWithOpacity = _a.transitionWithOpacity, animate = _a.animate;
    var handleClick = function (e) {
        if (portal)
            e.stopPropagation();
        if (e.target !== e.currentTarget)
            return;
        if (onClick)
            onClick(e);
    };
    var BackdropClassNames = classnames_1.default('Backdrop', 'Backdrop--is-visible', {
        'Backdrop--portal': portal,
        'd-f': transitionWithOpacity,
        'cursor-not-allowed': !closeOnClick,
    });
    var BackdropContentClassNames = classnames_1.default('Backdrop__content', className);
    return (react_1.default.createElement(internal_1.Portal, { conditional: portal },
        react_1.default.createElement(AnimatedWrapper, { animate: animate },
            react_1.default.createElement("div", { className: BackdropClassNames, ref: ref },
                react_1.default.createElement(AnimatedDiv, { animate: animate },
                    react_1.default.createElement("div", { className: "Backdrop--ClickHandler", onClick: handleClick })),
                react_1.default.createElement("div", { className: BackdropContentClassNames }, children)))));
});
var AnimatedWrapper = function (_a) {
    var animate = _a.animate, children = _a.children;
    return animate ? react_1.default.createElement(framer_motion_1.AnimatePresence, null, children) : children;
};
var AnimatedDiv = function (_a) {
    var animate = _a.animate, children = _a.children;
    var durationSlow = parseInt(tokens_1.default.durationSlow, 10) / 1000; // '300ms' -> 0.3
    var framerAnimation = {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { type: 'linear', duration: durationSlow },
    };
    return animate ? (react_1.default.createElement(framer_motion_1.motion.div, __assign({}, framerAnimation), children)) : (children);
};
//# sourceMappingURL=Backdrop.js.map